(function(){
    'use strict';
    angular.module('Services').service('NotificationsService', NotificationsService);
    NotificationsService.$inject = ['$rootScope'];

    function NotificationsService($rootScope) {
        const storageName = 'notifications';
        return {
            addNotificationData: (data) => {
                const storageData = angular.fromJson(localStorage.getItem(storageName)) || [];
                storageData.push(data);

                localStorage.setItem(storageName, angular.toJson(storageData));
                $rootScope.$broadcast('notif-updated');
            },
            getNotifications: () => {
                return angular.fromJson(localStorage.getItem(storageName)) || [];
            },
            removeNotifications: (data) => {
                const notifications = angular.fromJson(localStorage.getItem(storageName));
                const newData = notifications.filter(notif => notif.id !== data.id);

                localStorage.setItem(storageName, angular.toJson(newData));
                $rootScope.$broadcast('notif-updated');
            },
            updateNotificationDuration: () => {
                const storageData = angular.fromJson(localStorage.getItem(storageName)) || [];
                const updatedData = []; 

                storageData.forEach(dat => {
                    const duration = moment().diff(dat.time, 'minutes'); 
                    dat.duration = duration;
                    updatedData.push(dat);
                }); 
                localStorage.setItem(storageName, angular.toJson(updatedData));
                $rootScope.$broadcast('notif-updated');
            }, 
            removeExpiredNotifications: () => {
                const storageData = angular.fromJson(localStorage.getItem(storageName)) || [];
                const updatedData = storageData.filter(notif => {
                    const timePassed = moment().diff(notif.time, 'minutes');
                    return timePassed <= 30;
                });
                
                localStorage.setItem(storageName, angular.toJson(updatedData));
                $rootScope.$broadcast('notif-updated');
            },
            clearNotifications: () => {
                localStorage.removeItem(storageName);
            }
        };
    }
})();


// WEBPACK FOOTER //
// ./js/services/NotificationsService.js